import { Show } from "solid-js"
import { useApplication } from "@/context/session-provider"
import { RightPanel } from "@/designSystem/patterns/right-panel"
import { useI18nContext } from "@/i18n/i18n-solid"
import { createBlogRouter } from "@/routes/posts-router"
import { usePostEditor } from "./post-editor-context"
import { ShareContent } from "./post-share/share-content"

export function PostShare() {
  const postEditor = usePostEditor()
  const { LL } = useI18nContext()
  const { paths } = createBlogRouter()
  const { user } = useApplication()

  return (
    <Show
      when={!postEditor.isLoading() && postEditor.post()}
      fallback={<div>{LL().common.loading()}</div>}
    >
      {post => (
        <RightPanel
          closeHref={paths().post().url}
          header={{
            type: "title",
            title: LL().post.share(),
          }}
        >
          <ShareContent post={post()!} userName={user.publication!.name} />
        </RightPanel>
      )}
    </Show>
  )
}
